import { ToolUIPart, UIMessagePart } from 'ai';

import {
  PathwayUIDataParts,
  PathwayUIMessage,
  PathwayUITools,
} from '../../../types';

export const getPlainText = (message: PathwayUIMessage): string =>
  message.parts
    .filter(p => p.type === 'text')
    .map(p => p.text)
    .join('\n');

export const getCreatedAt = (message: PathwayUIMessage): string => {
  if (message.metadata?.createdAt) {
    return new Date(message.metadata.createdAt).toISOString();
  }
  return new Date().toISOString();
};

export const groupIntoSteps = (
  parts: UIMessagePart<PathwayUIDataParts, PathwayUITools>[],
) => {
  const steps: UIMessagePart<PathwayUIDataParts, PathwayUITools>[][] = [];

  let currentStep:
    | UIMessagePart<PathwayUIDataParts, PathwayUITools>[]
    | undefined;
  for (const part of parts) {
    if (part.type === 'step-start') {
      if (currentStep) {
        steps.push(currentStep);
      }
      currentStep = [];
      continue;
    }
    currentStep?.push(part);
  }

  if (currentStep) {
    steps.push(currentStep);
  }

  return steps;
};

export const partIsTool = (
  part: UIMessagePart<PathwayUIDataParts, PathwayUITools>,
): part is ToolUIPart<PathwayUITools> => part.type.startsWith('tool');

/* ---- START Reasoning ---- */

const MAX_TITLE_LENGTH = 100;

const stripMarkdown = (text: string) =>
  text
    .replace(/```[\s\S]*?```/g, match =>
      match.replace(/```[^\n]*\n?|\n?```/g, ' '),
    )
    .replace(/`([^`]+)`/g, '$1')
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/^\s{0,3}(#{1,6}\s*|>\s?)/gm, '')
    .replace(/^\s*([-*+]|\d+\.)\s+/gm, '')
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    .replace(/~~(.*?)~~/g, '$1')
    .replace(/[\\*_#>`]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const getReasoningTitle = (text: string) => {
  const strippedText = stripMarkdown(text);

  return strippedText.length > MAX_TITLE_LENGTH
    ? `${strippedText.slice(0, MAX_TITLE_LENGTH)}...`
    : strippedText;
};

/* ---- END Reasoning ---- */
